import React from 'react';
import image from '../../../Assets/Cards/ipadDemo.webp';
import  ipad from '../../../Assets/Icons/ipad.svg';
import AppPart from '../../Shared/AppPart/AppPart';

const Demo=()=>{
    return(
        <>
        <AppPart 
        title="The digital products, from around the world, that you know and love have been built with Hostdesign."
        desc="Our apps let you create, play and share on the go."
        backgroundImage1 = {ipad}
        image={image}
        />
        </>
    )
};
export default Demo ;